import { css } from 'lit';
import { CzContentloader } from '@cz/webcomponents';

export default class CzMFAloader extends CzContentloader {

	static styles = [
		CzContentloader.styles,
		css`
			@layer component {
				:host(:empty) {
					aspect-ratio: 1/.325;
				}
			}
		`
	];

	#sidepanel = false;
	#loaded = false;
	#loadOnSidepanelOpen = false;
	#mfaUrl = false;
	#mfaName = false;

	mfaTemplate = false;

	startLoading() {
		this.loadContent().then((r) => {
			if (r && this.#mfaUrl) {
				const scriptFileEl = document.createElement('script');
				scriptFileEl.setAttribute('async', '');
				scriptFileEl.setAttribute('src', `${this.#mfaUrl}/${this.#mfaName}/main.js`);
				this.appendChild(scriptFileEl);
			}
		});
	}

	sideOverlayObserve() {
		if (!this.#sidepanel) {
			return;
		}

		const config = {
			attributeFilter: ['open'],
		};

		const callback = async (mutationList) => {
			for (const mutation of mutationList) {
				if (mutation.type === "attributes" && mutation.attributeName === 'open') {
					if (this.#sidepanel?.hasAttribute('open') && !this.#loaded) {
						this.startLoading();
					}
				}
			}
		};

		const observer = new MutationObserver(callback);
		observer.observe(this.#sidepanel, config);

		if (this.#sidepanel?.hasAttribute('open') && !this.#loaded) {
			this.startLoading();
		}
	}

	callBackend = async (url) => {
		if (this.#loadOnSidepanelOpen && this.#sidepanel && !this.#sidepanel.hasAttribute('open')) {
			return '';
		}

		let result = this.mfaTemplate ? this.mfaTemplate.innerHTML : 'Something went wrong, please try again later.';
		this.#loaded = true;
		return result;
	}

	constructor() {
		super();
		this.#loadOnSidepanelOpen = this.getAttribute('load-on-sidepanel-open');
		this.#mfaUrl = this.getAttribute('app-url');
		this.#mfaName = this.getAttribute('app-name');
		this.#sidepanel = this.closest('cz-sidepanel');
		this.mfaTemplate = document.getElementById(this.getAttribute('template'));
		if (this.#loadOnSidepanelOpen && this.#sidepanel) {
			this.sideOverlayObserve();
		} else {
			this.startLoading();
		}
	}
}

if (!customElements.get('cz-mfaloader')) {
	customElements.define('cz-mfaloader', CzMFAloader);
}